// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/attribute/v1/attribute.proto" (package "c1.api.attribute.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * CreateAttributeValueResponse is the response for creating an attribute value.
 *
 * @generated from protobuf message c1.api.attribute.v1.CreateAttributeValueResponse
 */
export interface CreateAttributeValueResponse {
    /**
     * @generated from protobuf field: c1.api.attribute.v1.AttributeValue value = 1;
     */
    value?: AttributeValue;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.CreateAttributeValueRequest
 */
export interface CreateAttributeValueRequest {
    /**
     * @generated from protobuf field: string attribute_type_id = 1;
     */
    attributeTypeId: string;
    /**
     * @generated from protobuf field: string value = 2;
     */
    value: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.CreateComplianceFrameworkAttributeValueResponse
 */
export interface CreateComplianceFrameworkAttributeValueResponse {
    /**
     * @generated from protobuf field: c1.api.attribute.v1.AttributeValue value = 1;
     */
    value?: AttributeValue;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.CreateComplianceFrameworkAttributeValueRequest
 */
export interface CreateComplianceFrameworkAttributeValueRequest {
    /**
     * @generated from protobuf field: string value = 1;
     */
    value: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.DeleteComplianceFrameworkAttributeValueRequest
 */
export interface DeleteComplianceFrameworkAttributeValueRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.DeleteComplianceFrameworkAttributeValueResponse
 */
export interface DeleteComplianceFrameworkAttributeValueResponse {
}
/**
 * @generated from protobuf message c1.api.attribute.v1.GetComplianceFrameworkAttributeValueRequest
 */
export interface GetComplianceFrameworkAttributeValueRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.GetComplianceFrameworkAttributeValueResponse
 */
export interface GetComplianceFrameworkAttributeValueResponse {
    /**
     * @generated from protobuf field: c1.api.attribute.v1.AttributeValue value = 1;
     */
    value?: AttributeValue;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.CreateRiskLevelAttributeValueResponse
 */
export interface CreateRiskLevelAttributeValueResponse {
    /**
     * @generated from protobuf field: c1.api.attribute.v1.AttributeValue value = 1;
     */
    value?: AttributeValue;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.CreateRiskLevelAttributeValueRequest
 */
export interface CreateRiskLevelAttributeValueRequest {
    /**
     * @generated from protobuf field: string value = 1;
     */
    value: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.DeleteRiskLevelAttributeValueRequest
 */
export interface DeleteRiskLevelAttributeValueRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.DeleteRiskLevelAttributeValueResponse
 */
export interface DeleteRiskLevelAttributeValueResponse {
}
/**
 * @generated from protobuf message c1.api.attribute.v1.GetRiskLevelAttributeValueRequest
 */
export interface GetRiskLevelAttributeValueRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.GetRiskLevelAttributeValueResponse
 */
export interface GetRiskLevelAttributeValueResponse {
    /**
     * @generated from protobuf field: c1.api.attribute.v1.AttributeValue value = 1;
     */
    value?: AttributeValue;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.GetAttributeValueRequest
 */
export interface GetAttributeValueRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * GetAttributeValueResponse is the response for getting an attribute value by id.
 *
 * @generated from protobuf message c1.api.attribute.v1.GetAttributeValueResponse
 */
export interface GetAttributeValueResponse {
    /**
     * @generated from protobuf field: c1.api.attribute.v1.AttributeValue value = 1;
     */
    value?: AttributeValue;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.ListComplianceFrameworksRequest
 */
export interface ListComplianceFrameworksRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.ListComplianceFrameworksResponse
 */
export interface ListComplianceFrameworksResponse {
    /**
     * @generated from protobuf field: repeated c1.api.attribute.v1.AttributeValue list = 1;
     */
    list: AttributeValue[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.ListRiskLevelsRequest
 */
export interface ListRiskLevelsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.ListRiskLevelsResponse
 */
export interface ListRiskLevelsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.attribute.v1.AttributeValue list = 1;
     */
    list: AttributeValue[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * AttributeType defines the type of an attribute.
 *
 * @generated from protobuf message c1.api.attribute.v1.AttributeType
 */
export interface AttributeType {
    /**
     * The ID of the AttributeType.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * The name of the AttributeType.
     *
     * @generated from protobuf field: string name = 2;
     */
    name: string;
}
/**
 * AttributeValue is the value of an attribute of a defined type.
 *
 * @generated from protobuf message c1.api.attribute.v1.AttributeValue
 */
export interface AttributeValue {
    /**
     * The ID of the AttributeValue.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * The ID of the AttributeType that this AttributeValue belongs to.
     *
     * @generated from protobuf field: string attribute_type_id = 2;
     */
    attributeTypeId: string;
    /**
     * The value of the AttributeValue. This is the string that will be displayed to the user.
     *
     * @generated from protobuf field: string value = 3;
     */
    value: string;
    /**
     * The datetime, in RFC3339 format, of when the AttributeValue was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AttributeValue was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5;
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AttributeValue was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6;
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.GetAttributeValuesRequest
 */
export interface GetAttributeValuesRequest {
    /**
     * @generated from protobuf field: repeated string attribute_ids = 1;
     */
    attributeIds: string[];
}
/**
 * @generated from protobuf message c1.api.attribute.v1.GetAttributeValuesResponse
 */
export interface GetAttributeValuesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.attribute.v1.AttributeValue items = 1;
     */
    items: AttributeValue[];
}
/**
 * @generated from protobuf message c1.api.attribute.v1.ListAttributeValuesRequest
 */
export interface ListAttributeValuesRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string attribute_type_id = 3;
     */
    attributeTypeId: string;
}
/**
 * ListAttributeValuesResponse is the response for listing attribute values for a given AttributeType.
 *
 * @generated from protobuf message c1.api.attribute.v1.ListAttributeValuesResponse
 */
export interface ListAttributeValuesResponse {
    /**
     * The list of AttributeValues.
     *
     * @generated from protobuf field: repeated c1.api.attribute.v1.AttributeValue list = 1;
     */
    list: AttributeValue[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.attribute.v1.DeleteAttributeValueRequest
 */
export interface DeleteAttributeValueRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * DeleteAttributeValueResponse is the empty response for deleting an attribute value.
 *
 * @generated from protobuf message c1.api.attribute.v1.DeleteAttributeValueResponse
 */
export interface DeleteAttributeValueResponse {
}
/**
 * @generated from protobuf message c1.api.attribute.v1.ListAttributeTypesRequest
 */
export interface ListAttributeTypesRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * ListAttributeTypesResponse is the response for listing attribute types.
 *
 * @generated from protobuf message c1.api.attribute.v1.ListAttributeTypesResponse
 */
export interface ListAttributeTypesResponse {
    /**
     * The list of AttributeTypes.
     *
     * @generated from protobuf field: repeated c1.api.attribute.v1.AttributeType list = 1;
     */
    list: AttributeType[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * Search Attributes by a few properties.
 *
 * @generated from protobuf message c1.api.attribute.v1.SearchAttributeValuesRequest
 */
export interface SearchAttributeValuesRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * Query the attributes with a fuzzy search on display name and description.
     *
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * The attribute type ids for what type of attributes to search for.
     *
     * @generated from protobuf field: repeated string attribute_type_ids = 4;
     */
    attributeTypeIds: string[];
    /**
     * Exclude attributes with these ids from the search results.
     *
     * @generated from protobuf field: repeated string exclude_ids = 5;
     */
    excludeIds: string[];
    /**
     * Include attributes with these ids in the search results.
     *
     * @generated from protobuf field: repeated string ids = 6;
     */
    ids: string[];
    /**
     * Search for attributes with a case insensitive match on the attribute value which is the attribute name.
     *
     * @generated from protobuf field: string value = 7;
     */
    value: string;
}
/**
 * SearchAttributeValuesResponse is the response for searching AttributeValues.
 *
 * @generated from protobuf message c1.api.attribute.v1.SearchAttributeValuesResponse
 */
export interface SearchAttributeValuesResponse {
    /**
     * The list of returned AttributeValues.
     *
     * @generated from protobuf field: repeated c1.api.attribute.v1.AttributeValue list = 1;
     */
    list: AttributeValue[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class CreateAttributeValueResponse$Type extends MessageType<CreateAttributeValueResponse> {
    constructor() {
        super("c1.api.attribute.v1.CreateAttributeValueResponse", [
            { no: 1, name: "value", kind: "message", T: () => AttributeValue }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.CreateAttributeValueResponse
 */
export const CreateAttributeValueResponse = new CreateAttributeValueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAttributeValueRequest$Type extends MessageType<CreateAttributeValueRequest> {
    constructor() {
        super("c1.api.attribute.v1.CreateAttributeValueRequest", [
            { no: 1, name: "attribute_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.CreateAttributeValueRequest
 */
export const CreateAttributeValueRequest = new CreateAttributeValueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateComplianceFrameworkAttributeValueResponse$Type extends MessageType<CreateComplianceFrameworkAttributeValueResponse> {
    constructor() {
        super("c1.api.attribute.v1.CreateComplianceFrameworkAttributeValueResponse", [
            { no: 1, name: "value", kind: "message", T: () => AttributeValue }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.CreateComplianceFrameworkAttributeValueResponse
 */
export const CreateComplianceFrameworkAttributeValueResponse = new CreateComplianceFrameworkAttributeValueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateComplianceFrameworkAttributeValueRequest$Type extends MessageType<CreateComplianceFrameworkAttributeValueRequest> {
    constructor() {
        super("c1.api.attribute.v1.CreateComplianceFrameworkAttributeValueRequest", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.CreateComplianceFrameworkAttributeValueRequest
 */
export const CreateComplianceFrameworkAttributeValueRequest = new CreateComplianceFrameworkAttributeValueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteComplianceFrameworkAttributeValueRequest$Type extends MessageType<DeleteComplianceFrameworkAttributeValueRequest> {
    constructor() {
        super("c1.api.attribute.v1.DeleteComplianceFrameworkAttributeValueRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.DeleteComplianceFrameworkAttributeValueRequest
 */
export const DeleteComplianceFrameworkAttributeValueRequest = new DeleteComplianceFrameworkAttributeValueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteComplianceFrameworkAttributeValueResponse$Type extends MessageType<DeleteComplianceFrameworkAttributeValueResponse> {
    constructor() {
        super("c1.api.attribute.v1.DeleteComplianceFrameworkAttributeValueResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.DeleteComplianceFrameworkAttributeValueResponse
 */
export const DeleteComplianceFrameworkAttributeValueResponse = new DeleteComplianceFrameworkAttributeValueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetComplianceFrameworkAttributeValueRequest$Type extends MessageType<GetComplianceFrameworkAttributeValueRequest> {
    constructor() {
        super("c1.api.attribute.v1.GetComplianceFrameworkAttributeValueRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.GetComplianceFrameworkAttributeValueRequest
 */
export const GetComplianceFrameworkAttributeValueRequest = new GetComplianceFrameworkAttributeValueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetComplianceFrameworkAttributeValueResponse$Type extends MessageType<GetComplianceFrameworkAttributeValueResponse> {
    constructor() {
        super("c1.api.attribute.v1.GetComplianceFrameworkAttributeValueResponse", [
            { no: 1, name: "value", kind: "message", T: () => AttributeValue }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.GetComplianceFrameworkAttributeValueResponse
 */
export const GetComplianceFrameworkAttributeValueResponse = new GetComplianceFrameworkAttributeValueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRiskLevelAttributeValueResponse$Type extends MessageType<CreateRiskLevelAttributeValueResponse> {
    constructor() {
        super("c1.api.attribute.v1.CreateRiskLevelAttributeValueResponse", [
            { no: 1, name: "value", kind: "message", T: () => AttributeValue }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.CreateRiskLevelAttributeValueResponse
 */
export const CreateRiskLevelAttributeValueResponse = new CreateRiskLevelAttributeValueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRiskLevelAttributeValueRequest$Type extends MessageType<CreateRiskLevelAttributeValueRequest> {
    constructor() {
        super("c1.api.attribute.v1.CreateRiskLevelAttributeValueRequest", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.CreateRiskLevelAttributeValueRequest
 */
export const CreateRiskLevelAttributeValueRequest = new CreateRiskLevelAttributeValueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRiskLevelAttributeValueRequest$Type extends MessageType<DeleteRiskLevelAttributeValueRequest> {
    constructor() {
        super("c1.api.attribute.v1.DeleteRiskLevelAttributeValueRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.DeleteRiskLevelAttributeValueRequest
 */
export const DeleteRiskLevelAttributeValueRequest = new DeleteRiskLevelAttributeValueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRiskLevelAttributeValueResponse$Type extends MessageType<DeleteRiskLevelAttributeValueResponse> {
    constructor() {
        super("c1.api.attribute.v1.DeleteRiskLevelAttributeValueResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.DeleteRiskLevelAttributeValueResponse
 */
export const DeleteRiskLevelAttributeValueResponse = new DeleteRiskLevelAttributeValueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRiskLevelAttributeValueRequest$Type extends MessageType<GetRiskLevelAttributeValueRequest> {
    constructor() {
        super("c1.api.attribute.v1.GetRiskLevelAttributeValueRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.GetRiskLevelAttributeValueRequest
 */
export const GetRiskLevelAttributeValueRequest = new GetRiskLevelAttributeValueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRiskLevelAttributeValueResponse$Type extends MessageType<GetRiskLevelAttributeValueResponse> {
    constructor() {
        super("c1.api.attribute.v1.GetRiskLevelAttributeValueResponse", [
            { no: 1, name: "value", kind: "message", T: () => AttributeValue }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.GetRiskLevelAttributeValueResponse
 */
export const GetRiskLevelAttributeValueResponse = new GetRiskLevelAttributeValueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAttributeValueRequest$Type extends MessageType<GetAttributeValueRequest> {
    constructor() {
        super("c1.api.attribute.v1.GetAttributeValueRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.GetAttributeValueRequest
 */
export const GetAttributeValueRequest = new GetAttributeValueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAttributeValueResponse$Type extends MessageType<GetAttributeValueResponse> {
    constructor() {
        super("c1.api.attribute.v1.GetAttributeValueResponse", [
            { no: 1, name: "value", kind: "message", T: () => AttributeValue }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.GetAttributeValueResponse
 */
export const GetAttributeValueResponse = new GetAttributeValueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListComplianceFrameworksRequest$Type extends MessageType<ListComplianceFrameworksRequest> {
    constructor() {
        super("c1.api.attribute.v1.ListComplianceFrameworksRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.ListComplianceFrameworksRequest
 */
export const ListComplianceFrameworksRequest = new ListComplianceFrameworksRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListComplianceFrameworksResponse$Type extends MessageType<ListComplianceFrameworksResponse> {
    constructor() {
        super("c1.api.attribute.v1.ListComplianceFrameworksResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AttributeValue },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.ListComplianceFrameworksResponse
 */
export const ListComplianceFrameworksResponse = new ListComplianceFrameworksResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRiskLevelsRequest$Type extends MessageType<ListRiskLevelsRequest> {
    constructor() {
        super("c1.api.attribute.v1.ListRiskLevelsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.ListRiskLevelsRequest
 */
export const ListRiskLevelsRequest = new ListRiskLevelsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRiskLevelsResponse$Type extends MessageType<ListRiskLevelsResponse> {
    constructor() {
        super("c1.api.attribute.v1.ListRiskLevelsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AttributeValue },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.ListRiskLevelsResponse
 */
export const ListRiskLevelsResponse = new ListRiskLevelsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AttributeType$Type extends MessageType<AttributeType> {
    constructor() {
        super("c1.api.attribute.v1.AttributeType", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.AttributeType
 */
export const AttributeType = new AttributeType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AttributeValue$Type extends MessageType<AttributeValue> {
    constructor() {
        super("c1.api.attribute.v1.AttributeValue", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "attribute_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.AttributeValue
 */
export const AttributeValue = new AttributeValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAttributeValuesRequest$Type extends MessageType<GetAttributeValuesRequest> {
    constructor() {
        super("c1.api.attribute.v1.GetAttributeValuesRequest", [
            { no: 1, name: "attribute_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "100", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.GetAttributeValuesRequest
 */
export const GetAttributeValuesRequest = new GetAttributeValuesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAttributeValuesResponse$Type extends MessageType<GetAttributeValuesResponse> {
    constructor() {
        super("c1.api.attribute.v1.GetAttributeValuesResponse", [
            { no: 1, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AttributeValue }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.GetAttributeValuesResponse
 */
export const GetAttributeValuesResponse = new GetAttributeValuesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAttributeValuesRequest$Type extends MessageType<ListAttributeValuesRequest> {
    constructor() {
        super("c1.api.attribute.v1.ListAttributeValuesRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "attribute_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.ListAttributeValuesRequest
 */
export const ListAttributeValuesRequest = new ListAttributeValuesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAttributeValuesResponse$Type extends MessageType<ListAttributeValuesResponse> {
    constructor() {
        super("c1.api.attribute.v1.ListAttributeValuesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AttributeValue },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.ListAttributeValuesResponse
 */
export const ListAttributeValuesResponse = new ListAttributeValuesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAttributeValueRequest$Type extends MessageType<DeleteAttributeValueRequest> {
    constructor() {
        super("c1.api.attribute.v1.DeleteAttributeValueRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.DeleteAttributeValueRequest
 */
export const DeleteAttributeValueRequest = new DeleteAttributeValueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAttributeValueResponse$Type extends MessageType<DeleteAttributeValueResponse> {
    constructor() {
        super("c1.api.attribute.v1.DeleteAttributeValueResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.DeleteAttributeValueResponse
 */
export const DeleteAttributeValueResponse = new DeleteAttributeValueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAttributeTypesRequest$Type extends MessageType<ListAttributeTypesRequest> {
    constructor() {
        super("c1.api.attribute.v1.ListAttributeTypesRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.ListAttributeTypesRequest
 */
export const ListAttributeTypesRequest = new ListAttributeTypesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAttributeTypesResponse$Type extends MessageType<ListAttributeTypesResponse> {
    constructor() {
        super("c1.api.attribute.v1.ListAttributeTypesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AttributeType },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.ListAttributeTypesResponse
 */
export const ListAttributeTypesResponse = new ListAttributeTypesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAttributeValuesRequest$Type extends MessageType<SearchAttributeValuesRequest> {
    constructor() {
        super("c1.api.attribute.v1.SearchAttributeValuesRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "attribute_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "5", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "exclude_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.SearchAttributeValuesRequest
 */
export const SearchAttributeValuesRequest = new SearchAttributeValuesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAttributeValuesResponse$Type extends MessageType<SearchAttributeValuesResponse> {
    constructor() {
        super("c1.api.attribute.v1.SearchAttributeValuesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AttributeValue },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.attribute.v1.SearchAttributeValuesResponse
 */
export const SearchAttributeValuesResponse = new SearchAttributeValuesResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.attribute.v1.Attributes
 */
export const Attributes = new ServiceType("c1.api.attribute.v1.Attributes", [
    { name: "CreateComplianceFrameworkAttributeValue", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/attributes/compliance_frameworks", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Compliance Framework" }], group: "Compliance Framework" }] } }, I: CreateComplianceFrameworkAttributeValueRequest, O: CreateComplianceFrameworkAttributeValueResponse },
    { name: "DeleteComplianceFrameworkAttributeValue", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/attributes/compliance_frameworks/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Compliance Framework" }], group: "Compliance Framework" }] } }, I: DeleteComplianceFrameworkAttributeValueRequest, O: DeleteComplianceFrameworkAttributeValueResponse },
    { name: "GetComplianceFrameworkAttributeValue", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/attributes/compliance_frameworks/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Compliance Framework" }], group: "Compliance Framework" }] } }, I: GetComplianceFrameworkAttributeValueRequest, O: GetComplianceFrameworkAttributeValueResponse },
    { name: "CreateRiskLevelAttributeValue", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/attributes/risk_levels", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Risk Level" }], group: "Risk Level" }] } }, I: CreateRiskLevelAttributeValueRequest, O: CreateRiskLevelAttributeValueResponse },
    { name: "DeleteRiskLevelAttributeValue", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/attributes/risk_levels/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Risk Level" }], group: "Risk Level" }] } }, I: DeleteRiskLevelAttributeValueRequest, O: DeleteRiskLevelAttributeValueResponse },
    { name: "GetRiskLevelAttributeValue", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/attributes/risk_levels/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Risk Level" }], group: "Risk Level" }] } }, I: GetRiskLevelAttributeValueRequest, O: GetRiskLevelAttributeValueResponse },
    { name: "ListComplianceFrameworks", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/attributes/compliance_frameworks", query: { page_size: "page_size", page_token: "page_token" }, terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Compliance Frameworks", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "Compliance Framework" }] } }, I: ListComplianceFrameworksRequest, O: ListComplianceFrameworksResponse },
    { name: "ListRiskLevels", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/attributes/risk_levels", query: { page_size: "page_size", page_token: "page_token" }, terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Risk Levels", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "Risk Level" }] } }, I: ListRiskLevelsRequest, O: ListRiskLevelsResponse },
    { name: "CreateAttributeValue", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/attributes", group: "Attribute" }] } }, I: CreateAttributeValueRequest, O: CreateAttributeValueResponse },
    { name: "GetAttributeValue", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/attributes/{id}", group: "Attribute" }] } }, I: GetAttributeValueRequest, O: GetAttributeValueResponse },
    { name: "GetAttributeValues", options: { "authz.method": { role: "VIEWER" } }, I: GetAttributeValuesRequest, O: GetAttributeValuesResponse },
    { name: "ListAttributeValues", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/attributes/types/{attribute_type_id}/values", query: { page_size: "page_size", page_token: "page_token" }, group: "Attribute" }] } }, I: ListAttributeValuesRequest, O: ListAttributeValuesResponse },
    { name: "DeleteAttributeValue", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/attribute/{id}", group: "Attribute" }] } }, I: DeleteAttributeValueRequest, O: DeleteAttributeValueResponse },
    { name: "ListAttributeTypes", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/attributes/types", query: { page_size: "page_size", page_token: "page_token" }, group: "Attribute" }] } }, I: ListAttributeTypesRequest, O: ListAttributeTypesResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.attribute.v1.AttributeSearch
 */
export const AttributeSearch = new ServiceType("c1.api.attribute.v1.AttributeSearch", [
    { name: "SearchAttributeValues", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/attributes", group: "Attribute" }] } }, I: SearchAttributeValuesRequest, O: SearchAttributeValuesResponse }
]);
